



























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AppModal from './ui/Modal.vue';
import playerService from '@/shared/services/PlayerService';
import TeamImage from '@/shared/components/ui/TeamImage.vue';
@Component({
    components: {
        AppModal,
        TeamImage,
    },
})
export default class PlayerModal extends Vue {
    @Prop() private open!: boolean;
    @Prop() private playerId?: number;

    private player = null;

    private close() {
        this.$emit('close');
    }

    private async mounted() {
        if (this.playerId) {
            this.player = await playerService.fetchPlayerInfo(this.playerId);
        }
    }

    @Watch('playerId')
    private async onplayerIdChanged() {
        this.player = await playerService.fetchPlayerInfo(this.playerId);
    }
}
